<template>
  <div class="container college2">
    <div class="content-b">
      <div class="course">
        <!-- <div class="course-title">平台教程</div> -->
        <div class="course-item" v-for="(item, index) in college" :key="index">
          <div class="item-img">
            <video
              preload="metadata"
              controls
              :webkit-playsinline="true"
              :id="'video'+index"
              :src="item.video"
              v-if="item.isPlay"
              @play="onPlay"
              @pause="onPause"
              :style="{width:width,height:height}"
            ></video>
            <img class="cover-img" v-lazy="item.image" v-if="!item.isPlay" />
            <img
              class="play-img"
              src="../../assets/1.png"
              v-if="!item.isPlay"
              @click="playVideo(index)"
            />
          </div>
          <div class="item-title">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { constants } from "fs";
export default {
  data() {
    return {
      college: []
    };
  },

  mounted() {
    this.width = document.documentElement.clientWidth + "px";
    this.height = document.documentElement.clientHeight + "px";
    this.getCollege();
  },
  methods: {
    // 学院
    getCollege() {
      this.$api.college().then(res => {
        res.data.forEach(item => {
          item.isPlay = false;
        });
        this.college = res.data;
        console.log(this.college)
      });
    },
    // 视频播放
    playVideo(index) {
      console.log(index);
      console.log(this.college)
      this.college[index].isPlay = true;
      setTimeout(() => {
        let id = "video" + index;
        let vdo = document.getElementById(id);
        console.log(vdo);
        // if (vdo.requestFullscreen) {
        //   vdo.requestFullscreen();
        // } else if (vdo.mozRequestFullScreen) {
        //   vdo.mozRequestFullScreen();
        // } else if (vdo.webkitRequestFullScreen) {
        //   vdo.webkitRequestFullScreen();
        // }
        vdo.play();
      }, 100);
    },
    // 监控视频播放
    onPlay() {},
    // 视频暂停
    onPause() {
      this.college.forEach(item => {
        item.isPlay = false;
      });
    },
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #f6f6f6;
}

.college2 .top {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.4rem;
  padding: 0 0.21rem;
  background: #ffffff;
}
.college2 .top-item {
  width: 3.44rem;
  height: auto;
}
.college2 .top-item:first-child {
  margin-right: 0.2rem;
}
.college2 .course {
  background: #ffffff;
  padding: 0 0.21rem;
  padding-top: 0.4rem;
  /* margin-top: 0.25rem; */
  margin-bottom: 0.03rem;
}
.college2 .course-title {
  font-size: 0.32rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  height: 0.31rem;
  line-height: 0.31rem;
  text-align: left;
}
.college2 .course-item {
  padding-top: 0.3rem;
  border-bottom: 0.02rem solid #f3f3f3;
}
.college2 .course-item:last-child {
  border-bottom: none;
}
.college2 .item-img {
  width: 7.08rem;
  height: 3.98rem;
  border-radius: 0.1rem;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
}
.college2 .item-img .cover-img {
  width: 100%;
  height: 100%;
}
.college2 .item-img .play-img {
  width: 1rem;
  height: 1rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.college2 .item-img video {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  background: #000;
}
.college2 .item-title {
  font-size: 0.28rem;
  color: #222222;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  line-height: 0.27rem;
  padding: 0.3rem 0;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/college/index.vue